import Localization from 'lib/localization';

export default {
    lxBlockTitle() {
        return Localization.get('badoo_safety_center@hero_block.title');
    },
};
